'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import { Row, Col, Input, Table, Tree, Select } from 'antd';
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import smProjDndConfig from 'rt-sd-common/sgiConfig/smProjDndConfig'

const TreeNode = Tree.TreeNode;
const Option = Select.Option;

const treeConfConstant = {
    childrenName: 'cldSet',
    key: '_key',
}

const columns = [{
    //     title: '名称',
    //     dataIndex: 'n',
    //     width: 40
    // }, {
    title: '显示名称',
    dataIndex: 'te',
    width: 40,
    render: (text, record) => text || record.n
}, {
    title: 'GUID',
    dataIndex: 'guid',
    width: 80
}];

class Dnd_SgiFormEditorSCSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,//加载标志
            selValues: {}, //查询条件
            store: [],//表格的store
            selStore: [], //给查询用的，保证永远都是最全的
            keysTreeNode: {},//树节点key存储
            treeData: [],//树的数据组
            treeStore: [],//树的子节点数组
            didUpdate: false,//是否已更新，更新后执行使用
            attname: this.props.attname,//对应属性名不一定一样
            ap: tool.Global.currentAP,//当前ap
            aps: [],//可选ap数组
            apOptions: [],//select选项数组
        };
    }

    // 刷新
    refresh() {
        this.setState({ loading: false });
    }

    // ap切换
    apOnChange(e) {
        let ap = e.target.value;
        this.state.ap = ap;//切换ap
        this.initSCs();//重载参数
        this.onSel();//即时查询
    }
    // ap切换
    apSelectOnChange(e) {
        let ap = e;
        this.state.ap = ap;//切换ap
        this.initSCs();//重载参数
        this.onSel();//即时查询
    }

    // 重载参数
    initSCs() {
        let ap = this.state.ap;
        if (!ap) return;
        let tt = this.props.tt || "SC";
        // let prms = PrmFactory.getPrmByTT(ap, tt) || [];
        let prms = smProjDndConfig.getPrmByTT(ap, tt) || [];
        this.state.store = prms;//存在同步问题，这里不能使用setState
        this.state.selStore = prms;//存在同步问题，这里不能使用setState
        this.refresh();
    }

    //及时筛选
    selOnChange(attname, e, e2) {
        let value = e.target.value;
        this.state.selValues[attname] = value;
        this.setState({ loading: false });
        this.onSel();
    }

    //筛选方法
    onSel() {
        const { mat } = this.state.selValues;
        if (!mat) {
            this.setState(this.state.selStore);
        }
        let reg;
        if (mat) {
            reg = new RegExp(mat, 'gi');
        }
        this.setState({
            store: this.state.selStore.filter((e, i, a) => {
                // return e.n.match(reg) || e.te.match(reg) || e.guid.match(reg);
                return testBykey(e, "n") || testBykey(e, "te") || testBykey(e, "guid");
            })
        });

        function testBykey(record, key) {
            return record && record[key] && record[key].match(reg);
        }
    }

    //单击事件
    onClick(record, index) {
        this.state.treeData = [record];
        this.setState({ didUpdate: false });
    }

    //双击选中事件
    onDoubleClick(record) {
        let p = this.props.parentModule;
        let values = p.state.values;
        let val = record.guid;
        let attname = this.state.attname;
        values[attname] = val;
        p.setState({ [this.props.visibleKey || "SCModalVisible"]: false });

        p.refresh(attname, val);
    }

    //树节点全展开方法
    expandAll() {
        let keys = [];
        for (let key in this.state.keysTreeNode) {
            keys.push(key);
        }
        this.setState({ expandedKeys: keys, didUpdate: true });
    }

    //递归创建树节点方法
    fitTreeNodes = (data) => data.map((item) => {
        //因为树的key很重要，不能重复，数据中可能会有重复的key，所以检查是否有重复的key如果有，重新生成一个
        if (!item[treeConfConstant.key]) {
            item[treeConfConstant.key] = uuid(6);
        }

        if (this.state.keysTreeNode[item[treeConfConstant.key]]) { //存在重新生成一个 不存在添加进去
            item[treeConfConstant.key] = uuid(6);
        }

        let childrenName = treeConfConstant.childrenName;
        let currentNode;

        if (item[childrenName] && item[childrenName].length) {
            currentNode = <TreeNode itemData={item} tree={this} key={item[treeConfConstant.key]} title={(item.n || item.te) + (item.c ? ("[" + item.c + "]") : "")}>
                {this.fitTreeNodes(item[childrenName])}</TreeNode>
            currentNode.props.children.forEach(element => {
                element.props.parentNode = currentNode;
            });
            this.state.keysTreeNode[item[treeConfConstant.key]] = currentNode; //统一存起来
            return currentNode;
        }
        let LeafTreeNode = <TreeNode itemData={item} tree={this} key={item[treeConfConstant.key]} title={(item.n || item.te) + (item.c ? ("[" + item.c + "]") : "")} isLeaf />;
        this.state.keysTreeNode[item[treeConfConstant.key]] = LeafTreeNode; //统一存起来
        return LeafTreeNode;
    });

    //创建树
    createTreeStore() {
        this.state.keysTreeNode = {};
        this.state.treeStore = this.fitTreeNodes(this.state.treeData);
    }

    render() {

        this.createTreeStore();

        return (
            <div style={{ height: '100%', width: '100%' }}>
                <Row style={{ margin: '5px 0px 5px 0px' }}>
                    <Col span={4} style={{ padding: "0px 5px 0px 5px" }}>
                        {/* <Input addonBefore="AP" value={this.state.ap} onChange={this.apOnChange.bind(this)} /> */}
                        <Select value={this.state.ap} onChange={this.apSelectOnChange.bind(this)} style={{ width: "100%" }}>
                            {this.state.apOptions}
                        </Select>
                    </Col>
                    <Col span={12} style={{ padding: "0px 5px 0px 5px" }}>
                        <Input addonBefore="筛选条件" value={this.state.selValues.mat} onChange={this.selOnChange.bind(this, 'mat')} />
                    </Col>
                </Row>
                <Row>
                    <Col span={16}>
                        <Table size="small" dataSource={this.state.store} rowKey={'guid'} columns={columns}
                            onRowClick={this.onClick.bind(this)}
                            onRowDoubleClick={this.onDoubleClick.bind(this)}
                        />
                    </Col>
                    <Col span={8} >
                        <div style={{ overflow: 'auto', height: "420px" }}>
                            <Tree
                                defaultExpandAll
                                showLine={true}
                                expandedKeys={this.state.expandedKeys}
                            >
                                {this.state.treeStore}
                            </Tree>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    componentWillMount() {
        let aps = PrmFactory.getAPList() || [];
        aps.forEach((item, index) => {
            this.state.apOptions.push(<Option value={item.c}>{item.c}</Option>);
        })
        this.initSCs();//加载参数
    }

    componentDidUpdate() {
        if (!this.state.didUpdate) this.expandAll();//展开树节点
    }
}

export default Dnd_SgiFormEditorSCSelect;


// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorSCSelect.js